import { gsap,Back } from "gsap";
import { StageLayer } from '@nolimitcity/slot-launcher/bin/StageLayer';
import { ResizeHelper } from "../../../core/utils/ResizeHelper";
import { Helper } from '../../../core/utils/Helper';
import {  Sequence } from "../../../core/displayobject/Sequence";
import { SanQuentin2 } from "../../SanQuentin2";
import { BLEND_MODES } from "pixi.js";

export class BorderAnim extends PIXI.Container implements StageLayer {
    private readonly WIDTH:number = 3600;
    private readonly HEIGHT:number = 3600;

    private timeline:gsap.core.Timeline;
    private FireBorder:Sequence[];
    private fireMaxSize:number = 200;
    private blackGraphics:PIXI.Graphics;

    public get isIgnited():boolean{
        return !!this.FireBorder[0].alpha;
    }

    constructor(){ 
        super();
        this.initAnimations(); 
    };

    protected initAnimations():void{
        this.createGraphics();

        this.FireBorder = [];
        const seqBot = this.addChild(new Sequence("borderFire"));
        seqBot.anchor.set(0.5,1)
        seqBot.blendMode = BLEND_MODES.ADD;
        seqBot.play({repeat:-1,speedFactor:1.5});
        seqBot.position.set(-720,120);
        this.FireBorder.push(seqBot);

        const seqTop = this.addChild(new Sequence("borderFire"));
        seqTop.blendMode = BLEND_MODES.ADD;
        seqTop.anchor.set(0.5,1)
        seqTop.angle = 180;
        seqTop.play({repeat:-1,speedFactor:1.5});
        this.FireBorder.push(seqTop)

        const seqLeft = this.addChild(new Sequence("borderFire"));
        seqLeft.blendMode = BLEND_MODES.ADD;
        seqLeft.anchor.set(0.5,1)
        seqLeft.play({repeat:-1,speedFactor:1.5});
        seqLeft.angle = 90;
        this.FireBorder.push(seqLeft)

        const seqRight = this.addChild(new Sequence("borderFire"));
        seqRight.blendMode = BLEND_MODES.ADD;
        seqRight.anchor.set(0.5,1)
        seqRight.angle = -90;
        seqRight.play({repeat:-1,speedFactor:1.5});
        this.FireBorder.push(seqRight)

        this.FireBorder.forEach(seq =>{
            seq.alpha = 0;
        })

        this.onResize();
    }

    private createGraphics():void{
        this.blackGraphics = new PIXI.Graphics();
        this.blackGraphics.alpha = 0;
        this.blackGraphics.interactive = false;
        this.blackGraphics.buttonMode = false;

        this.blackGraphics.beginFill( 0x000000, 1);
        this.blackGraphics.drawRect(-this.WIDTH/2,-this.HEIGHT/2,this.WIDTH, this.HEIGHT);
        this.blackGraphics.endFill();

        this.addChild(this.blackGraphics);
    }

    IgniteFire():void{
        SanQuentin2.reelEngineManager.bounceScreen(0.98,2.5);
        this.timeline = Helper.setTimeline(this.timeline);
        this.timeline.fromTo(this.FireBorder,{height:0,alpha:0},{height:80,alpha:0.6,duration:2},0)
        this.timeline.fromTo(this.blackGraphics,{alpha:0},{alpha:0.3,duration:0.3},0)
        this.timeline.to(this.blackGraphics,{alpha:0,duration:2},0.3)
    }

    PulseLevel(lvl:number):void{
        if(!this.isIgnited)return;
        // SanQuentin2.reelEngineManager.bounceScreen(0.975,0.6);
        const sizeTarget = 80 + 20*(lvl+1)
        const sizeTargetOver = 80 + 30*(lvl+1)
        this.timeline = Helper.setTimeline(this.timeline);
        this.timeline.to(this.FireBorder,{height:sizeTargetOver, duration:0.3},0)
        this.timeline.to(this.FireBorder,{height:sizeTarget, duration:0.7},0.5)
        this.timeline.fromTo(this.blackGraphics,{alpha:0},{alpha:0.1,duration:0.1},0)
        this.timeline.to(this.blackGraphics,{alpha:0,duration:1},0.1)
    }

    killFire():void{
        if(!this.isIgnited)return;
        this.timeline = Helper.setTimeline(this.timeline);
        this.timeline.to(this.FireBorder,{height:50,alpha:0,duration:3},0)
    }

    public onResize(){

        const definedHeightOffset = (ResizeHelper.resizeData.height - 720)/2;
        //Bottom
        this.FireBorder[0].width = ResizeHelper.resizeData.width;
        this.FireBorder[0].position.y = (ResizeHelper.resizeData.height +20) - definedHeightOffset;
        this.FireBorder[0].position.x = ResizeHelper.resizeData.center;

        //Top
        this.FireBorder[1].width = ResizeHelper.resizeData.width;
        this.FireBorder[1].position.y = -definedHeightOffset + -20 ;
        this.FireBorder[1].position.x = ResizeHelper.resizeData.center;

        const definedWidthOffset = (ResizeHelper.resizeData.width - 720)/2;
        //Left
        this.FireBorder[2].width = ResizeHelper.resizeData.height;
        this.FireBorder[2].position.y = ResizeHelper.resizeData.center;
        this.FireBorder[2].position.x =  -definedWidthOffset + -20;

        //Right
        this.FireBorder[3].width = ResizeHelper.resizeData.height;
        this.FireBorder[3].position.y = ResizeHelper.resizeData.center;
        this.FireBorder[3].position.x =  (ResizeHelper.resizeData.width) - definedWidthOffset + 20;

        // console.log(ResizeHelper.resizeData)
        // console.log(ResizeHelper.resizeData.width)
        // console.log(this.FireBorder[0].height/2);
        // this.FireBorder[0].position.y = ResizeHelper.resizeData.bottom - ResizeHelper.resizeData.center;
    }
}